import { render, staticRenderFns } from "./GroupPopular.vue?vue&type=template&id=35753d22&scoped=true"
import script from "./GroupPopular.vue?vue&type=script&lang=js"
export * from "./GroupPopular.vue?vue&type=script&lang=js"
import style0 from "./GroupPopular.vue?vue&type=style&index=0&id=35753d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35753d22",
  null
  
)

export default component.exports